// extracted by mini-css-extract-plugin
var _1 = "TopicPills-module__child--bw2t5";
var _2 = "TopicPills-module__more--ZErv0";
var _3 = "TopicPills-module__pills--Z9bYd";
export { _1 as "child", _2 as "more", _3 as "pills" }
